import {
  faBicycle,
  faCar,
  faChild,
  faGlassWater,
  faPersonSwimming,
  faPumpSoap,
  faVideo,
  faWifi,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import "./Facilitiy_Modal.css";

const facilities = [
  { label: "CCTV", icon: faVideo },
  { label: "Wi Fi", icon: faWifi },
  { label: "Bike Parking", icon: faBicycle },
  { label: "Car Parking", icon: faCar },
  { label: "Sanitizer", icon: faPumpSoap },
  { label: "Drinking Water", icon: faGlassWater },
  { label: "Childcare", icon: faChild },
  { label: "Swimming Pool", icon: faPersonSwimming },
];

const Facilitiy_Modal = ({ show, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="facility_modal"
      backdrop="static"
    >
      <Modal.Body className="facility_modal_body">
        {/* Header */}
        <div className="facility_modal_header">
          <h5>Other Facilities</h5>
          <span className="close_btn" onClick={onHide}>
            ×
          </span>
        </div>

        {/* List */}
        <div className="facility_list">
          {facilities.map((item, index) => (
            <div className="facility_item" key={index}>
              <div className="facility_left">
                <FontAwesomeIcon icon={item.icon} />
                <span>{item.label}</span>
              </div>

              <input type="checkbox" className="checkbox" />
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Facilitiy_Modal;
